export default "__VITE_ASSET__1111bebd__"